<template>
  <v-dialog v-model="dialog" max-width="600" transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text x-small color="info" @click="setCurrentImapact" v-bind="attrs" v-on="on">
        {{ $t("report.thgCheckoutSustainableFactorDialog.edit") }}
      </v-btn>
    </template>

    <v-card flat>
      <v-card-title :style="partnerColor.gradientStyle">
        <span :style="`color:white`">{{ $t("report.thgCheckoutSustainableFactorDialog.title") }}</span>
        <v-spacer />
      </v-card-title>
      <v-subheader v-if="item.impactTypeQuestion" class="mt-4"> {{ $t(item.impactTypeQuestion) }} </v-subheader>
      <v-card-text class="mt-4">
        <v-chip
          class="mr-2 mb-2"
          label
          outlined
          color="primary"
          @click="value = impactfactor"
          v-for="(impactfactor, idx) of predefinedValues"
          :key="idx"
          >{{ impactfactor + " %" }}</v-chip
        >
      </v-card-text>
      <v-subheader>{{ $t("report.thgCheckoutSustainableFactorDialog.description") }}</v-subheader>
      <v-slider
        class="mt-12 mx-4"
        color="primary"
        min="1"
        step="1"
        track-color="grey"
        thumb-label="always"
        v-model="value"
      >
        <template v-slot:thumb-label="{ value }">
          {{ value + " %" }}
        </template>
      </v-slider>

      <v-card-actions>
        <v-btn class="mb-2" outlined color="success" @click="close">{{
          $t("report.thgCheckoutSustainableFactorDialog.close")
        }}</v-btn>
        <v-btn class="mb-2" color="success" elevation="0" @click="save" dark>{{
          $t("report.thgCheckoutSustainableFactorDialog.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { PartnerColor } from "@/lib/partnerColor";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";
import { IThgImpact } from "@/views/thg/interface/ThgImpact.interface";
import { ThgCreateModule } from "@/store/modules/thg.create.store";

@Component({
  components: {}
})
export default class ThgCheckoutSustainableFactorDialog extends DarkModeHighlightMixin {
  @Prop()
  item!: IThgImpact;

  UPDATE_IMPACTFACTOR = "update";
  value = 0;

  dialog = false;

  predefinedValues = [5, 10, 30, 50, 100];

  setCurrentImapact() {
    this.value = ThgCreateModule.impactFactor;
  }

  close() {
    this.dialog = false;
  }

  save() {
    this.dialog = false;
    this.$emit(this.UPDATE_IMPACTFACTOR, this.value);
  }

  partnerColor = new PartnerColor();
}
</script>
